<template>
    <transition name="fade-slide">
        <div class="brt-login-drawer" v-if="visible">
            <div class="brt-login fade-slide-top">

                <div class="close" @click="close">
                    <i class="iconfont icon-close-02"></i>
                </div>

                <div class="brt-login-title" v-if="step == 0">
                    <span> <i class="iconfont icon-huiyuandenglu"></i> 登录尊享数据云同步</span>
                </div>

                <div class="brt-login-body">

                    <div :class="phone.length > 0 ? 'input border':'input'" v-if="step == 0">

                        <input type="text" onfocus='this.blur()' @click="inputFocus"  v-model="phone" placeholder="输入手机号"  readonly/>

                        <i @click.stop="phone = ''" v-if="phone.length > 0" class="iconfont icon-close-01"></i>

                    </div>

                    <!--<div class="input">-->
                        <!--<input type="text" v-model="code" placeholder="验证码" />-->
                        <!--<span @click="getCode">获取验证码</span>-->
                    <!--</div>-->

                    <div class="code-box" v-if="step == 1">

                        <p>短信验证码</p>

                        <p>已发送{{phone}}</p>

                        <p class="code"><span v-for="(item,index) in spanCode" :class="index == codeIndex ? 'active':''" @click="codeIndex = index">{{item}}</span></p>
                    </div>


                    <div class="button" :status = 'step'>

                        <span v-if="step == 0" @click="login">获取验证码</span>
                        <!--<span>立即登录</span>-->

                        <span v-if="step == 1" @click="step = 0">修改手机号</span>
                        <span v-if="step == 1" :status="getCodeT" @click="getCodeT > 0 ? '':getCode()">

                            <span v-if="getCodeT > 0">{{getCodeT}}s重发</span>
                            <span v-else>重新发送</span>

                        </span>

                    </div>
                </div>
            </div>


            <KeyboderNum v-model="keyNumVisible" @on-result='numKeyDown'></KeyboderNum>
        </div>
    </transition>
</template>

<script>

    import {HOST} from "@/config/config"
    import $request from '@/utils/request'
    import {getCollectData,getHistoryFootData,getCode,verifyCode,addHistoryFootData} from '@/config/prepare.js';
    import KeyboderNum from '@/components/keyboard/Key_Number.vue';

    let $spancode = [];

    for(var i=0;i<4;i++){
        $spancode.push('');
    }

    export default {
        name: "Login1",
        data () {
            return {
                visible: this.value,
                phone:'',
                lastPhone:'',
                code:'',
                step:0,
                getCodeT:60,
                spanCode:JSON.parse(JSON.stringify($spancode)),
                codeIndex:0,
                keyNumVisible:true,
            }
        },
        props: {
            value: {
                default: false
            },

            saveOpen:{
                default:false,
            }
        },
        watch: {
            value (boolean) {

                this.visible = boolean;
                this.empty();

            },


            saveOpen(boolean){

                if(boolean){//保存

                    // console.log('保存boolean',boolean);
                }
            }

        },

        components:{
            KeyboderNum
        },

        methods: {

            empty(){

                this.phone = '';
                this.lastPhone = '';
                this.code = '';
                this.step = 0;
                this.getCodeT= 60;
                this.spanCode = JSON.parse(JSON.stringify($spancode));
                this.codeIndex = 0;

            },

            numKeyDown(item){
                // console.log('item',item);

                if(this.step == 0){ //手机号输入

                    //手机限制11位
                    if(this.phone.length>11){

                        this.$message.info('手机号格式不正确');
                        this.phone = this.phone.slice(0,11);
                    }


                    if(item.key == 10){

                        this.phone = '';

                    }else if(item.key == 12){
                        this.phone =   this.phone.slice(0,this.phone.length -1);
                    }else{
                        this.phone += item.value
                    }

                }else{//验证码输入


                    if(item.key == 10){

                        this.spanCode = JSON.parse(JSON.stringify($spancode));
                        this.codeIndex=0;

                    }

                    else if(item.key == 12){

                        this.codeIndex--;
                        this.spanCode[this.codeIndex] = '';

                    }

                    else{


                        if(this.codeIndex == 4)return false;

                        this.spanCode[this.codeIndex] = item.value;
                        this.codeIndex++;

                        this.code = '';

                         this.spanCode.map((item)=>{
                             this.code += item;
                         })

                        if(this.codeIndex == 4 && this.code.length ==4){
                            this.login();
                        }

                    }


                }


            },

            inputFocus(){

                this.keyNumVisible = true;
            },


            inputBlur(){
                // console.log('2');
            },

            inputCode(){
                // console.log('输入code值');
            },

            close () {
                this.$emit('input', this.visible = false);
            },

            verPhone(val){
                //校验手机号
                let regexp = /^[1][3,4,5,7,8][0-9]{9}$/;

                if(!regexp.test(val)){
                    this.$message.info('手机号格式不正确');
                    this.phone = '';
                }

                return regexp.test(val);
            },

            login(){

                if(this.step == 0){

                    this.getCode();



                }else{

                    if(this.verPhone(this.phone)){

                        if(!this.code){this.$message.info('请输入验证码');return;}

                        let $postD = `sign=${this.$mapStore.plugInfo.sign}&phone=${this.phone}&code=${this.code}`,

                            _callback = (res)=>{

                                if(res.code && res.code == 1){

                                    this.$message.info('登录失败')

                                }else {

                                    if(res.data.code == 1){

                                        this.$message.info(res.data.message)

                                    }else if(res.data.code == 0){

                                        this.$message.info('登录成功');


                                        this.$mapStore.plugInfo.phone = this.phone;
                                        window.localStorage.setItem('phone',this.phone);
                                        window.sessionStorage.setItem('pluginInfo',JSON.stringify(this.$mapStore.plugInfo))


                                        if(this.saveOpen && this.saveOpen == 1){

                                            //登录并保存历史足迹
                                            getHistoryFootData(this,(res)=>{
                                                // console.log('历史足迹',res);
                                                this.$store.state.HistoryData = res.data.result ? res.data.result:[];

                                                // 防止重复保存
                                                let $this = this,$brtmap= $this.$BRT;
                                                let $res = $this.$store.state.HistoryData.some((item,index,self)=>{

                                                    return JSON.parse(item.startPoi).POI_ID == $brtmap.$selecte.startPoint.POI_ID && JSON.parse(item.endPoi).POI_ID == $brtmap.$selecte.endPoint.POI_ID

                                                })

                                                if(!$res){

                                                    addHistoryFootData($this,{endPoi:$brtmap.$selecte.endPoint,startPoi:$brtmap.$selecte.startPoint},(res)=>{
                                                        // console.log('保存历史足迹成功',res);
                                                        getHistoryFootData($this,($res)=>{  //改变值
                                                            $this.$store.state.HistoryData = $res.data.result;
                                                        })

                                                    })
                                                }

                                            })


                                        }else{

                                            /**********获取收藏夹列表************/
                                            getCollectData(this,(res)=>{
                                                // console.log('收藏夹',res);
                                                this.$store.state.CollectData = res.data.result ? res.data.result:[];

                                            });

                                            /**********获取历史足迹列表************/
                                            getHistoryFootData(this,(res)=>{
                                                // console.log('历史足迹',res);
                                                this.$store.state.HistoryData = res.data.result ? res.data.result:[];
                                            })

                                        }

                                        this.$emit('input', this.visible = false);
                                    }
                                }
                            };

                        verifyCode($postD,_callback)
                        // $request.post(HOST + '/api/v1/verifyCode?'+$postD).then((res)=>{
                        //     // console.log('登录成功',res);
                        //
                        //     if(res.data.code == 1){
                        //
                        //         this.$message.info(res.data.message)
                        //
                        //     }else if(res.data.code == 0){
                        //
                        //         this.$message.info('登录成功');
                        //         this.$mapStore.plugInfo.phone = this.phone;
                        //
                        //         window.localStorage.setItem('phone',this.phone);
                        //         window.sessionStorage.setItem('pluginInfo',JSON.stringify(this.$mapStore.plugInfo))
                        //
                        //
                        //         /**********获取收藏夹列表************/
                        //         getCollectData(this,(res)=>{
                        //             console.log('收藏夹',res);
                        //             this.$store.state.CollectData = res.data.result ? res.data.result:[];
                        //
                        //         });
                        //
                        //         /**********获取历史足迹列表************/
                        //         getHistoryFootData(this,(res)=>{
                        //             console.log('历史足迹',res);
                        //             this.$store.state.HistoryData = res.data.result ? res.data.result:[];
                        //         })
                        //
                        //
                        //         this.$emit('input', this.visible = false);
                        //     }
                        //
                        // }).catch((error)=>{
                        //
                        //     this.$message.info('登录失败')
                        //
                        // })
                    }
                }


            },

            getCode(){

                if(this.verPhone(this.phone)){


                    if(this.lastPhone && this.lastPhone == this.phone && this.getCodeT > 0){ //已经获取过验证码的(60s限制)

                        this.step = 1;
                        return false;

                    }

                    // let $postD = {sign:this.$mapStore.plugInfo.sign,phone:this.phone};

                    let $postD = `sign=${this.$mapStore.plugInfo.sign}&phone=${this.phone}`;


                    getCode($postD,res=>{

                        if((res.code && res.code == 1) || (res.data.code == 1)){
                            this.$message.info('获取验证码失败');
                            this.phone = '';
                        }else{

                            if(res.data.code == 0){

                                this.$message.info('获取验证码成功');
                                this.step = 1;
                                this.getCodeT = 60;

                                this.lastPhone = this.phone;

                                if($getCodeOnce)clearInterval($getCodeOnce);
                                var $getCodeOnce = setInterval(()=>{

                                    if(this.getCodeT <=0){

                                        clearInterval($getCodeOnce);
                                        return false;
                                    }

                                    this.getCodeT -- ;
                                },1000)
                            }
                        }

                    })

                    // $request.post(HOST + '/api/v1/sendSms?' + $postD).then((res)=>{
                    //
                    //     if(res.data.code == 0){
                    //         this.$message.info('获取验证码成功')
                    //     }
                    //
                    // }).catch((err)=>{
                    //
                    //     this.$message.info('获取验证码失败')
                    //
                    // })
                }
            }
        }
    }
</script>

<style lang="less">
    @import "../../styles/cssBlock.less";

    .brt-login-drawer {
        .fixedByCover();
        background-color: @maskBgColor !important;
        z-index: 9009;
        display: flex;
        flex-direction: column;
        align-items: center;

        > .brt-login {
            margin-top: @spacingNumber;
            width: 90%;
            max-width: @680px;
            min-height: 100px;
            background-color: #FFFFFF;
            border-radius: @radiusNumber;
            position: relative;

            > .close {
                @size       : @88px;
                position: absolute;
                right: 0;
                top: 0;
                width: @size;
                height: @size;
                line-height: @size;
                text-align: center;

                > .iconfont {
                    font-size: @36px;
                    color: @fontColorA2;
                }
            }

            > .brt-login-title {
                line-height: @90px;
                padding: 0 @spacingNumber;
                font-size: @fontSizeA4;
                color: var(--themColor);

                >span{
                    >i{font-size: @fontSizeA3}
                }
            }

            > .brt-login-body {
                padding: @spacingNumber * 1.5 @spacingNumber * 2;

                @height     : @80px;

                > .input {
                    margin-bottom: @spacingNumber;
                    position: relative;


                    >i{
                        position: absolute;
                        top: 50%;
                        right: 0px;
                        transform: translateY(-50%);
                        font-size: @fontSizeA3;
                        color: @fontColorA2;

                    }


                    &.border{

                        >input{
                            border-color: var(--themColor)
                        }
                    }

                    > input {
                        width: 100%;
                        height: @height;
                        border-bottom: 1px solid @borderColorA2;
                        border-radius: @radiusNumber;
                        padding: 0 @spacingNumber;
                        font-size: @normalFontSize - @2px;
                    }

                    > span {
                        display: inline-block;
                        width: @190px;
                        height: @height;
                        line-height: @height;
                        text-align: center;
                        font-size: @normalFontSize - @4px;
                        color: @fontColorA3;
                        position: absolute;
                        right: 0;
                        top: 0;

                        &:before {
                            content: '';
                            display: inline-block;
                            height: @20px;
                            border-left: 1px solid @borderColorA2;
                            position: absolute;
                            left: 0;
                            top: 50%;
                            margin-top: -@10px;
                        }
                    }
                }

                >.code-box{
                    color: @fontColorA2;

                    >p:first-child{
                        font-size: @fontSizeA4;
                    }

                    >p:nth-child(2){
                        font-size: @fontSizeA3;
                        /*font-weight: bold;*/
                        margin-top: @standartSpaceA1;
                        margin-bottom: @standartSpaceA6;
                        color: @fontColorA1;
                    }

                    >.code{

                        border:1px solid @borderColorA2;
                        border-top: 0px;
                        border-left: 0px;
                        line-height: 0px;
                        overflow: hidden;
                        clear: both;
                        >span{
                            display: inline-block;
                            width: 25%;
                            font-size: @fontSizeA1;
                            border: 1px solid @borderColorA2;
                            border-right: 0px;
                            border-bottom: 0px;
                            text-align: center;
                            height: @height * 1.2;
                            line-height: @height * 1.2;
                            font-weight: bold;
                            vertical-align: middle;
                            float: left;
                            &.active{
                                border: 1px solid var(--themColor);
                                box-shadow:-1px -1px 5px  var(--themShadow);
                            }
                        }


                    }
                }

                > .button {

                    .flexCenter();

                    justify-content: space-between;

                    margin-top: @spacingNumber * 1.5;

                    >span{
                        flex: 1;
                        display: inline-block;
                        height: @height;
                        line-height: @height;
                        text-align: center;
                        border-radius: @radiusNumber;
                        background-color: var(--themColor);
                        color: @themeReverseColor;

                        &:active {
                            background-color: @buttonActiveColor;
                        }

                    }

                    &[status = '1']{

                        >span{
                            border-radius: @height/2;
                            &:first-child{
                                background-color: transparent;
                                border:1px solid @borderColorA1;
                                color: @fontColorA3;
                            }
                            &:last-child{
                                margin-left: @standartSpaceA4;
                                background-color: @fontColorA3;

                                &[status = '0']{
                                    background-color: @themeColor;
                                }
                            }

                            &:active{
                                opacity: .8;
                            }
                        }

                    }
                }
            }

        }
    }

</style>
